import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { DatabaseGwService } from '../../../rds-objects/services/database-gw.service';
import { UploadImageService } from '../../../rds-utilities/upload-image.service';

@Component({
	selector: 'rds-upload-pdf',
	templateUrl: './upload-pdf.component.html',
	styleUrls: ['./upload-pdf.component.scss']
})
export class UploadPdfComponent implements OnInit {
 
	@Input() title: string = 'Upload PDF here';
	@Input() subtitle:string = "Drag and drop your PDF here or click here to browse it from your computer. File can't exceed 20MB.";
	@Input() clientName: string = "portal";
	@Input() userInfo: any = {};//required
	@Input() folder: string = 'photos';
	@Input() frameSize: string = '';//xs, sm (default), md,
	@Input() fromAction: string = 'all';//e.g. thumb-product

	@Output() callback: EventEmitter<any> = new EventEmitter();//event after image uplaoded
 
	files: File[] = [];
	activeFile: File;
	// userInfo: User = new User();
	isSaving: boolean = false;
	isDeleting: boolean = false; 

	constructor(@Inject('env') private $env,
		private $http: HttpClient,
		private $database: DatabaseGwService,
		private $uploadImage: UploadImageService,
	) { }

	ngOnInit() {
		this.$uploadImage.saveImageTrigger.subscribe(fromAction => {
			if (this.fromAction == "all" || fromAction == this.fromAction) {
				this.doUploadObjectImageField();
			}
		}); 
		this.clientName = this.$env.client;
	}

	onSelect(event: any) {
		this.files = [];
		this.files.push(event.addedFiles[0]);
		this.activeFile = event.addedFiles[0];
	}

	doUploadObjectImageField() {
		this.isSaving = true;
		let uploadStatus: any = {
			status: "error",
			message: (!this.userInfo.api_token ? "User Unauthorize!" : "Invalid File!"),
		}
		 
		//we allow only user has auth and there are a file
		if (this.activeFile && this.activeFile.name && this.userInfo.api_token) {
			let filenameExt: string = this.activeFile.name;
			let splitedName: any = filenameExt.split(".");
			let fileExtension: any = splitedName[splitedName.length - 1];
			let filename:string = splitedName[0];
			filename = filename.replace(/[^a-zA-Z0-9]+/gm, '-').toLowerCase();
			

			let fullImgUrl: string = `${this.$env.DOC_PATH}/${this.clientName}/${this.folder}`;
			let fileDist: string = `/${this.clientName}/${this.folder}`;
			let newFilename: string = `${fullImgUrl}/${filename}.${fileExtension}`; 

			let formData: FormData = new FormData(); 
			formData.append("name", filename);
			formData.append("path", fileDist);
			formData.append("file", this.activeFile); 

			let httpOptions: any = this.generateHttpOption();

			this.$http.post(this.$env.UPLOAD_DOC_EP, formData, httpOptions).subscribe(res => { 
 
				uploadStatus.status = "success";
				uploadStatus.message = "File is uploaded!";  
				uploadStatus.url = newFilename;
 
				this.isSaving = false;
				this.callback.emit(uploadStatus); 
			}, err => { 
				uploadStatus.message = err.error.message;
				this.isSaving = false;
				this.callback.emit(uploadStatus);
			});
		} else { 
			this.isSaving = false;
			this.callback.emit(uploadStatus);
		}
	}

	 

	onRemove(event) {  
		this.files.splice(this.files.indexOf(event), 1);
	} 
 

	generateHttpOption(){
		return {
			headers: new HttpHeaders({
				"Authorization": `Bearer ${this.userInfo.api_token}`,
				"client": this.clientName
			})
		};
	}

}
